export var NewUserQuestType;
(function (NewUserQuestType) {
    NewUserQuestType["OnChain"] = "onchain";
    NewUserQuestType["Pro"] = "pro";
    NewUserQuestType["SignupReward"] = "signupReward";
})(NewUserQuestType || (NewUserQuestType = {}));
